define('shared/initializer/form/adapters/mixins/MemberCreatable',[ 
    '$',
    '../../constants', 
    'shared/lib/RSVP',
    'shared/util/state', 
    'shared/util/state/adapters/form', 
    'shared/util/state/adapters/order', 
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/remote/member/cache',
    'shared/util/queryPersistence',
    'shared/lib/console',
    'shared/my/cmus',
    'shared/lib/cookie',
    'shared/remote/offer/get',
    'shared/util/checkout/member',
    'shared/util/checkout/checkout',
    'shared/util/state/adapters/pending',
    'shared/util/checkout/RedemptionCodeHelper',
    'shared/util/tracking/dailyLesson',
    'shared/util/tracking/pendingEvents',
    ],
function ( 
    $,
    constants, 
    RSVP, 
    state, 
    formAdapter,
    orderAdapter,
    FormDataDispatcher, 
    memberCache,
    queryPersistence,
    console,
    getCMus,
    cookie,
    getOffer,
    memberUtil,
    checkoutUtil,
    pendingAdapter,
    RedemptionCode,
    dailyLessonUtil,
    pendingEventsUtil
) {
    'use strict';

    function consumeRedemptionCode(){
        var me = this;

        return me.redemptionCode.consume()
            .then(function(orderId){
                if (!orderId) {
                    return RSVP.resolve();
                }

                return checkoutUtil
                    .handlePaymentSucceeded
                        .call(this, orderId);
            });
    }

    function Ctor(){}

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;

        if (!me.redemptionCode) {
            me.redemptionCode = new RedemptionCode(me.options.useRedemptionCode);
        }

        if(memberUtil.isUpdatingMemberInfo()){
            return RSVP.resolve();
        }

        return RSVP.resolve()
        .then(function(){
            return new FormDataDispatcher( me.$form ).dispatch({
                items:{
                    'EFID':
                    {
                        sources: [{type: 'state', key: 'user.ef_id', allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.EFID}]
                    },
                    'HasOffersTransactionId':
                    {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.hoTransactionId, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.HasOffersTransactionId}]
                    },
                    'GoogleClickId':
                    {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.gclid, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.GoogleClickId}]
                    },
                    'MarinClickId':
                    {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.ruboid, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MarinClickId}]
                    },
                    'utm_source': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_source, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberUtmSource}]
                    },
                    'utm_medium': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_medium, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberUtmMedium}]
                    },
                    'utm_campaign': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_campaign, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberUtmCampaign}]
                    },
                    'utm_term': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_term, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberUtmTerm}]
                    },
                    'utm_content': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_content, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberUtmContent}]
                    },
                    'adgroup': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.adgroup, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberAdGroup}]
                    },
                    'referredby': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.referredby, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberReferredBy}]
                    },
                    'referredfrom': {
                        sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.referredfrom, allowUndefined: true}],
                        targets: [{type: 'form', key: constants.FIELD.MemberReferredFrom}]
                    }
                },
                timeout: 1000 * 60 * 60
            });
        })
        .then(function(){
            var promise;

            if(cookie.get('CMus')){
                if (
                    me.options.memberCreatable && 
                    me.options.memberCreatable.disablePageOnLoadRedeem === true
                ) {
                    promise = RSVP.resolve();
                }
                else {
                    promise = consumeRedemptionCode.apply(me, arguments);
                }
                return promise;
            } else {
                return RSVP.resolve();
            }
        });
    };

    function getFormElementValue(elementName){
        var me = this;
        var $el = me.$form.find('input[name="' + elementName + '"]');
        return $el.val();
    }

    p.doBeforeRedirect = function( data ){
        var me = this;
        var memberId = null;
        var resolveData = RSVP.resolve(data);

        if(memberUtil.isUpdatingMemberInfo()){
            return resolveData;
        }

        return RSVP.resolve()
        .then(function(){
            return new RSVP.Promise(function(resolve, reject){
                var result = data && data.Result;

                if ( result == null ) {
                    reject('Server cannot process the data');
                    return;
                }

                memberId = result.Member_id;

                memberCache
                    .set(result)
                    .then(resolve, reject);
            });
        })
        .then(function(){
            if(!me.options.saveAsLead){
                return RSVP.resolve();
            }

            console.log('saving member as lead...');
            var leadType = 'ml';
            return new RSVP.Promise(function(resolve, reject){
                $.ajax({
                    url: '/online/landinghandler.ashx',
                    type: 'POST',
                    data: {
                        lp: 'true',
                        responsemode: 'json',
                        first_name: getFormElementValue.call(me, constants.FIELD.MemberFirstName),
                        last_name: getFormElementValue.call(me, constants.FIELD.MemberLastName),
                        email: getFormElementValue.call(me, constants.FIELD.MemberEmail),
                        local: getFormElementValue.call(me, constants.FIELD.MemberCountryCode),
                        partner: getFormElementValue.call(me, constants.FIELD.MemberPartner),
                        telephone: getFormElementValue.call(me, constants.FIELD.MemberHomePhone),
                        mobilePhone: getFormElementValue.call(me, constants.FIELD.MemberMobilePhone),
                        age: getFormElementValue.call(me, constants.FIELD.MemberAge),
                        memberid: memberId,
                        etag: getFormElementValue.call(me, constants.FIELD.MemberEtag),
                        lang: getFormElementValue.call(me, constants.FIELD.MemberLanguageCode),
                        omnitureFriendlyName2: getFormElementValue.call(me, constants.FIELD.MemberOmnitureFriendlyName),
                        LeadType: leadType,
                        hoTransactionId: getFormElementValue.call(me, constants.FIELD.MemberHasOffersTransactionId),
                        gclid: getFormElementValue.call(me, constants.FIELD.MemberGoogleClickId),
                        ruboid: getFormElementValue.call(me, constants.FIELD.MemberMarinClickId),
                        EFID: getFormElementValue.call(me, constants.FIELD.MemberEFID),
                        Description: 'AEM;ML;save member as lead',
                        utm_source: getFormElementValue.call(me, constants.FIELD.MemberUtmSource),
                        utm_medium: getFormElementValue.call(me, constants.FIELD.MemberUtmMedium),
                        utm_campaign: getFormElementValue.call(me, constants.FIELD.MemberUtmCampaign),
                        utm_term: getFormElementValue.call(me, constants.FIELD.MemberUtmTerm),
                        utm_content: getFormElementValue.call(me, constants.FIELD.MemberUtmContent),
                        adgroup: getFormElementValue.call(me, constants.FIELD.MemberAdGroup),
                        GAClientId: getFormElementValue.call(me, constants.FIELD.MemberGAClientId),
                        AdobeVisitorId: getFormElementValue.call(me, constants.FIELD.MemberAdobeVisitorId),
                        ReferredBy: getFormElementValue.call(me, constants.FIELD.MemberReferredBy),
                        ReferredFrom: getFormElementValue.call(me, constants.FIELD.MemberReferredFrom)
                    }
                })
                .then(
                    function (saveMemberAsLeadData) {
                        console.log('saveMemberAsLead received data:', saveMemberAsLeadData);

                        if(!saveMemberAsLeadData || !saveMemberAsLeadData.Success || !saveMemberAsLeadData.LeadId){
                            reject('saveMemberAsLead failed.');
                        }
                        else{
                            var leadId = saveMemberAsLeadData.LeadId;
                            console.log('saveMemberAsLead saved lead:', leadId);

                            RSVP.all([
                                state.push('form.lead_id', leadId),
                                state.push('form.leadtype', leadType),
                                pendingEventsUtil.add(constants.EVENT.LeadOnlineEnquiry)
                            ]).then(resolve, reject);
                        }
                    },
                    function (reason) {
                        var err = reason || new Error('Failed to save member as leads due to connection issue, please try again later.');
                        reject(err);
                    }
                );
            });
        })
        .then(function() {
            return pendingEventsUtil.add(constants.EVENT.MemberRegistration);
        })
        .then(function(){
            if(dailyLessonUtil.dailyLessonSubscribed.apply(me)){
                return pendingEventsUtil.add(constants.EVENT.EmailEnglish);
            }
            else{
                return RSVP.resolve();
            }
        })
        .then(function(){
            return consumeRedemptionCode.apply(me, arguments);
        })
        .then(function () {
            return resolveData;
        });
    };

    return Ctor;
});
